import { useState } from "react";
import { cases } from "@/mocks/home";

const categories = ["전체", "개인보험", "근재보험", "교통사고", "손해배상", "화재", "누수"];

export default function Cases() {
  const [active, setActive] = useState("전체");
  const filtered =
    active === "전체" ? cases : cases.filter((c) => c.tag === active);

  return (
    <section id="cases" className="bg-background-50 py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <div className="text-primary-600 text-xs tracking-[0.32em] font-semibold mb-4">
              OUR PORTFOLIO
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
              <span className="md:inline block">실제 <span className="text-primary-600">성공사례</span>로</span>
              <span className="md:inline block">증명합니다</span>
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-5 py-2 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap transition ${
                  active === c
                    ? "bg-foreground-950 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((c) => (
            <article
              key={c.ttl}
              className="group bg-background-50 border border-background-200/80 rounded-lg overflow-hidden hover:border-primary-400 transition"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={c.img}
                  alt={c.ttl}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                <span className="absolute top-4 left-4 bg-primary-500 text-background-50 text-xs font-semibold px-3 py-1 rounded-full">
                  {c.tag}
                </span>
              </div>
              <div className="p-6">
                <h3 className="font-heading font-bold text-lg text-foreground-950 leading-snug min-h-[56px]">
                  {c.ttl}
                </h3>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                  {c.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}